import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import IconButton from "components/Button/IconButton";
import { generateObjectZeroId } from "components/CommonLib/CommonLib";
import { CustomRow } from "components/CustomTable/tableStyle";
import TextField from "components/LabelInput/TextField";
import { useState } from "react";

// function createData(id, name) {
//   return {
//     name,
//   };
// }

// const rows = [createData(0, "Cupcake")];

export default function OrgEditTable(props) {
  const [selected, setSelected] = useState({ org_id: "", org_name: "" });
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(7);

  const rows = props.rest_call(props.rest_data);

  // const handleRequestSort = (event, property) => {
  //   const isAsc = orderBy === property && order === "asc";
  //   setOrder(isAsc ? "desc" : "asc");
  //   setOrderBy(property);
  // };

  // const handleSelectAllClick = (event) => {
  //   if (event.target.checked) {
  //     const newSelecteds = rows.map((n) => n.name);
  //     setSelected(newSelecteds);
  //     return;
  //   }
  //   setSelected([]);
  // };
  const onChangeValue = (idx, val) => {
    props.rawChange(idx, val);
  };

  const handleClick = (event, item) => {
    const selectedIndex = selected.org_name.indexOf(item.org_name);

    let newSelected = "";
    if (selectedIndex === -1) {
      newSelected = item;
    } else if (selectedIndex === 0) {
      newSelected = { org_id: "", org_name: "" };
    }

    // let newSelected = [];

    // if (selectedIndex === -1) {
    //   newSelected = newSelected.concat(selected, name);
    // } else if (selectedIndex === 0) {
    //   newSelected = newSelected.concat(selected.slice(1));
    // } else if (selectedIndex === selected.length - 1) {
    //   newSelected = newSelected.concat(selected.slice(0, -1));
    // } else if (selectedIndex > 0) {
    //   newSelected = newSelected.concat(
    //     selected.slice(0, selectedIndex),
    //     selected.slice(selectedIndex + 1),
    //   );
    // }

    props.selectChange(newSelected);
    setSelected(newSelected);
  };

  const isSelected = (name) => selected.org_name.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  return (
    <Box sx={{ width: "100%", height: "90%", overflow: "auto" }}>
      <Paper sx={{ width: "100%", mb: 2 }}>
        {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
        <TableContainer>
          <Table
            sx={{ overflow: "hidden" }}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
          >
            <TableBody>
              {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
              {rows
                // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  // console.log(props.titleName + index.toString());
                  const isItemSelected = isSelected(row.org_name);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <CustomRow
                      // hover
                      onFocus={(event) => handleClick(event, row)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.org_name}
                      selected={isItemSelected}
                    >
                      <TableCell padding="checkbox" style={{ width: "0px", padding: "0px" }}>
                        <Checkbox
                          style={{
                            width: "0px",
                            maxWidth: "0px", // percentage also works
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                        />
                      </TableCell>
                      {/* <TableCell component="th" id={labelId} scope="row" padding="none">
                        {row.org_name}
                      
                      </TableCell> */}
                      <TableCell align="center" style={{ width: "80%", padding: "0px" }}>
                        <TextField
                          id={props.titleName + index.toString()}
                          labelMarginRight="0rem"
                          // textBoxWidth="100%"
                          fullWidth
                          textMarginRight={"0rem"}
                          defaultValue={row.org_name}
                          onChangeCallback={(e) => {
                            // onChangeValue(index, e);
                          }}
                          onBlur={(e) => {
                            if (e.target.value === "") {
                              props.onDeleteItem(index);
                            } else {
                              props.onChangeDone(index, e.target.value);
                            }
                          }}
                          disabled={row.org_id !== generateObjectZeroId()}
                        />
                      </TableCell>

                      <TableCell align="right">
                        <IconButton
                          type="delete"
                          onClick={() => {
                            props.onClickDelete(index, row.org_name);
                          }}
                        />
                      </TableCell>
                    </CustomRow>
                  );
                })}
              {emptyRows > 0 && (
                <CustomRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={3} />
                </CustomRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
